export default "__VITE_ASSET__BmO616S___"